import { ActionIcon, Menu } from '@mantine/core';
import { IconTrashX, IconCopy, IconDots, IconArchive, IconArchiveOff } from '@tabler/icons';
import { FC, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { i18n } from '@lingui/core';
import { WorkflowS } from '../../../Service/WorkflowS';
import { WorkflowTemplateListViewDTO } from '../../../Types/LogT';
import { ViolationContext } from '../../../Service/Context/ViolationContext';
import { ToastS } from '../../../Service/ToastS';
import { openArchiveTemplateModal, openDeleteTemplateModal } from './WorkflowTemplateModals';

interface Props {
  template: WorkflowTemplateListViewDTO;
  remove: () => void;
  handleChange: (id: string, patch: Partial<WorkflowTemplateListViewDTO>) => void;
}

const WorkflowTemplateActions: FC<Props> = ({ template, handleChange, remove }) => {
  const { id, archived, enabled } = template;
  const navigate = useNavigate();
  const { interceptViolation } = useContext(ViolationContext);

  const duplicate = async () => {
    const copy = await WorkflowS.copyTemplate(id);
    if (copy) {
      const { id: copyId } = copy;
      navigate(`templates/${copyId}`);
      handleChange(id, { archived: false });
    }
  };

  const activate = async () => {
    const resJSON = await WorkflowS.editTemplate(id, { archived: false });
    if (resJSON) {
      ToastS.success('aktivate-template', 'Vorlage wurde aktiviert');
      handleChange(id, { archived: false });
    }
  };

  return (
    <Menu radius="md" shadow="md" width={150} transition="slide-down" position="bottom-end">
      <Menu.Target>
        <ActionIcon>
          <IconDots />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        {!archived && (
          <Menu.Item disabled={archived} icon={<IconCopy size={16} />} onClick={duplicate}>
            Duplizieren
          </Menu.Item>
        )}
        {!archived && !enabled && (
          <Menu.Item
            icon={<IconArchive size={16} />}
            onClick={() => openArchiveTemplateModal({ template, onFinish: () => handleChange(id, { archived: true }) })}
          >
            {i18n._('actions.archive')}
          </Menu.Item>
        )}
        {archived && (
          <Menu.Item icon={<IconArchiveOff size={16} />} onClick={activate}>
            Aktivieren
          </Menu.Item>
        )}
        <Menu.Item
          color="red"
          icon={<IconTrashX size={16} />}
          onClick={() => openDeleteTemplateModal({ template, onDelete: remove, interceptViolation })}
        >
          Löschen
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default WorkflowTemplateActions;
